import axios from "axios";
import { cloneDeep } from "lodash-es";

import { Mutation } from "@/shared/enums/store-partnership.enum";
import { StorePartnershipActions } from "@/shared/models/store-partnership.model";

const actions: StorePartnershipActions = {
  addClaim(_context, payload) {
    return (this as any).$api.call("smartphone.addClaim", payload);
  },

  async listClaim({ commit }, payload) {
    try {
      // Add user_timezone for partnership data listing
      const userTimezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Jakarta";

      Object.assign(payload.data, { user_timezone: userTimezone });

      const { tab } = payload;
      const validPayload = cloneDeep(payload);

      const Data = await (this as any).$api.call(
        "partnership.claimList",
        validPayload,
      );

      if (typeof tab === "undefined" && tab === null) {
        commit(Mutation.SetClaimList, Data.data);
      } else {
        commit(Mutation.SetClaimList, {
          data: Data.data,
          tab,
        });
      }

      commit(Mutation.SetClaimListMeta, Data.meta);
    } catch (error) {
      commit(Mutation.SetClaimList, []);
      commit(Mutation.SetClaimListMeta, {});

      throw error;
    }
  },

  async detailClaim({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.claimDetail",
        payload,
      );

      commit(Mutation.SetClaim, Data);
    } catch (error) {
      commit(Mutation.SetClaim, {});
      throw error;
    }
  },

  async listClaimsHistoriesClaim({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.historyClaimList",
        payload,
      );

      commit(Mutation.SetClaimHistory, Data);
    } catch (error) {
      commit(Mutation.SetClaimHistory, {});
      throw error;
    }
  },

  updateClaim(_context, payload) {
    return (this as any).$api.call("partnership.updateClaim", payload);
  },

  updateBulkClaim(_context, payload) {
    return (this as any).$api.call("partnership.updateBulkClaim", payload);
  },

  downloadAllClaim(_context, payload) {
    return (this as any).$api.call("partnership.downloadAllClaim", payload);
  },

  downloadAllClaimV2(_context, payload) {
    return (this as any).$api.call("partnership.downloadAllClaimV2", payload);
  },

  searchClaim(_context, payload) {
    return (this as any).$api.call("partnership.searchClaim", payload);
  },

  retryPayment(_context, payload) {
    return (this as any).$api.call("partnership.retryPayment", payload);
  },

  async listPolicy({ commit }, payload) {
    try {
      // Add user_timezone for partnership data listing
      const userTimezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Jakarta";

      Object.assign(payload.data, { user_timezone: userTimezone });

      const { tab } = payload;
      const validPayload = cloneDeep(payload);

      const Data = await (this as any).$api.call(
        "partnership.policyList",
        validPayload,
      );

      if (typeof tab === "undefined" && tab === null) {
        commit(Mutation.SetPolicyList, Data.data);
      } else {
        commit(Mutation.SetPolicyList, {
          data: Data.data,
          tab,
        });
      }

      commit(Mutation.SetPolicyListMeta, Data.meta);
    } catch (error) {
      commit(Mutation.SetPolicyList, []);
      commit(Mutation.SetPolicyListMeta, {});

      throw error;
    }
  },

  async detailPolicy({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.policyDetail",
        payload,
      );

      commit(Mutation.SetPolicy, Data);
    } catch (error) {
      commit(Mutation.SetPolicy, {});
      throw error;
    }
  },

  downloadAllPolicy(_context, payload) {
    return (this as any).$api.call("partnership.downloadAllPolicy", payload);
  },

  downloadAllPolicyV2(_context, payload) {
    return (this as any).$api.call("partnership.downloadAllPolicyV2", payload);
  },

  async getProductCodeList(_context, payload) {
    try {
      const { data } = await (this as any).$api.call(
        "partnership.productCodeList",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },
  async getPartnershipUploadPolicyPresignUrl(_context, payload) {
    try {
      const { data } = await (this as any).$api.call(
        "partnership.partnershipUploadPolicypresignUrl",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },
  async getPartnershipUploadClaimPresignUrl(_context, payload) {
    try {
      const { data } = await (this as any).$api.call(
        "partnership.partnershipUploadClaimpresignUrl",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },

  async hitPresignUrl(context, { buffer, url }) {
    try {
      await axios.put(url, buffer, {
        onUploadProgress: ({ loaded, total }) => {
          const progress = (loaded / total) * 100;
          context.commit(Mutation.SetUploadProgress, Math.round(progress));
        },
      });
    } catch (error) {
      context.commit(Mutation.SetUploadProgress, 0);
      throw error;
    }
  },

  async listPartners({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.listPartners",
        payload,
      );
      commit(Mutation.SetPartnerList, Data);
    } catch (error) {
      commit(Mutation.SetPartnerList, []);
      throw error;
    }
  },

  storeProduct({ commit }, product) {
    commit(Mutation.SetProduct, product);
  },

  async fetchProductList({ commit, rootState }) {
    const { code } = rootState.auth.userData.organization;

    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.productList",
        {
          params: { code },
        },
      );

      commit(Mutation.SetProductList, Data);
    } catch (error) {
      commit(Mutation.SetProductList, []);
      throw error;
    }
  },

  async getClaimPresignUrl(_context, payload) {
    try {
      const { data } = await (this as any).$api.call(
        "partnership.claimPresignUrl",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },

  async getProductCategoryList(_context, payload) {
    try {
      const { data } = await (this as any).$api.call(
        "partnership.productCategoryList",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },

  async getStoplossList(_context, payload) {
    try {
      const { data } = await (this as any).$api.call(
        "partnership.stoplossList",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },

  async getClaimFormList(_context, payload) {
    try {
      const data = await (this as any).$api.call(
        "partnership.claimFormList",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },

  async getClaimFormDetail(_context, payload) {
    try {
      const { data } = await (this as any).$api.call(
        "partnership.claimFormDetail",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },

  async getClaimLogList(_context, payload) {
    try {
      const data = await (this as any).$api.call(
        "partnership.claimLogList",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },

  async sharePolicy(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.sharePolicy",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async createInvoice(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.createInvoice",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async summaryInvoice(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.summaryInvoice",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getProductGroupList(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.productGroupList",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async listInvoice({ commit }, payload) {
    try {
      // Add user_timezone for partnership data listing
      const userTimezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Jakarta";

      Object.assign(payload.data, { user_timezone: userTimezone });

      const { tab } = payload;
      const validPayload = cloneDeep(payload);

      const Data = await (this as any).$api.call(
        "partnership.invoiceList",
        validPayload,
      );

      if (typeof tab === "undefined" && tab === null) {
        commit(Mutation.SetInvoiceList, Data.data);
      } else {
        commit(Mutation.SetInvoiceList, {
          data: Data.data,
          tab,
        });
      }

      commit(Mutation.SetInvoiceListMeta, Data.meta);
    } catch (error) {
      commit(Mutation.SetInvoiceList, []);
      commit(Mutation.SetInvoiceListMeta, {});

      throw error;
    }
  },

  async listClaimDisbursement({ commit }, payload) {
    try {
      // Add user_timezone for partnership data listing
      const userTimezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Jakarta";

      Object.assign(payload.data, { user_timezone: userTimezone });

      const { tab } = payload;
      const validPayload = cloneDeep(payload);

      const Data = await (this as any).$api.call(
        "partnership.claimDisbursementList",
        validPayload,
      );

      if (typeof tab === "undefined" && tab === null) {
        commit(Mutation.SetClaimDisbursementList, Data.data);
      } else {
        commit(Mutation.SetClaimDisbursementList, {
          data: Data.data,
          tab,
        });
      }

      commit(Mutation.SetClaimDisbursementListMeta, Data.meta);
    } catch (error) {
      commit(Mutation.SetClaimDisbursementList, []);
      commit(Mutation.SetClaimDisbursementListMeta, {});

      throw error;
    }
  },

  async detailClaimDisbursement({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.claimDisbursementDetail",
        payload,
      );
      commit(Mutation.SetClaimDisbursementDetail, Data);
    } catch (error) {
      commit(Mutation.SetClaimDisbursementDetail, {});
      throw error;
    }
  },

  async historyClaimDisbursement({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.historyClaimDisbursement",
        payload,
      );

      commit(Mutation.SetClaimDisbursementHistory, Data);
    } catch (error) {
      commit(Mutation.SetClaimDisbursementHistory, {});
      throw error;
    }
  },

  async updateStatusClaimDisbursement(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.updateStatusClaimDisbursement",
        payload,
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  async createClaimDisbursement(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.createClaimDisbursement",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async summaryClaimDisbursement(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.summaryClaimDisbursement",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async summaryDisbursementPayment(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.summaryDisbursementPayment",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async markAsPaidDisbursement(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.markAsPaidDisbursement",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async cancelClaimDisbursement(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.cancelClaimDisbursement",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async detailInvoice({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.invoiceDetail",
        payload,
      );

      commit(Mutation.SetInvoice, Data);
    } catch (error) {
      commit(Mutation.SetInvoice, {});
      throw error;
    }
  },

  async cancelInvoice(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.cancelInvoice",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async resendPaymentLink(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.resendPaymentLink",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async historyInvoice({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.historyInvoice",
        payload,
      );

      commit(Mutation.SetInvoiceHistory, Data);
    } catch (error) {
      commit(Mutation.SetInvoiceHistory, {});
      throw error;
    }
  },

  async summaryInvoicePayment(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.summaryInvoicePayment",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async markAsPaidInvoice(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.markAsPaidInvoice",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async listClaimPool({ commit }, payload) {
    try {
      const { tab } = payload;
      const validPayload = cloneDeep(payload);

      const Data = await (this as any).$api.call(
        "partnership.claimPoolList",
        validPayload,
      );

      if (typeof tab === "undefined" && tab === null) {
        commit(Mutation.SetClaimPoolList, Data.data);
      } else {
        commit(Mutation.SetClaimPoolList, {
          data: Data.data,
          tab,
        });
      }

      commit(Mutation.SetClaimPoolListMeta, Data.meta);
    } catch (error) {
      commit(Mutation.SetClaimPoolList, []);
      commit(Mutation.SetClaimPoolListMeta, {});

      throw error;
    }
  },

  async detailClaimPool({ commit }, payload) {
    try {
      const { data: Data } = await (this as any).$api.call(
        "partnership.claimPoolDetail",
        payload,
      );

      commit(Mutation.SetClaimPool, Data);
    } catch (error) {
      commit(Mutation.SetClaimPool, {});
      throw error;
    }
  },

  async historyClaimPool(_context, payload) {
    try {
      // Add user_timezone for partnership data listing
      const userTimezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Jakarta";

      Object.assign(payload.data, { user_timezone: userTimezone });

      const validPayload = cloneDeep(payload);

      const Data = await (this as any).$api.call(
        "partnership.claimPoolHistory",
        validPayload,
      );

      return Data;
    } catch (error) {
      throw error;
    }
  },

  async listNotificationTemplate(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.listNotificationTemplate",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async createNotificationTemplate(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.createNotificationTemplate",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async postProductDetail(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.postProductDetail",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async ocrInvoicePhoto(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.ocrInvoicePhoto",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async createQuotation(_context, payload) {
    try {
      const response = await (this as any).$api.call(
        "partnership.createQuotation",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async productVersionList(_context, payload) {
    try {
      const validPayload = cloneDeep(payload);

      const Data = await (this as any).$api.call(
        "partnership.productVersionList",
        validPayload,
      );

      return Data;
    } catch (error) {
      throw error;
    }
  },

  async gadgetListCatalog(_context, payload) {
    try {
      const response = await (this as any).$api.call("partnership.gadgetListCatalog", payload);
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        _context.commit("mutationGadgets", {
          responseData,
          tab: payload.tab,
        });

        // this is used for lazy loading (mobile)
        _context.commit("mutationGadgetsAll", {
          responseData,
          tab: payload.tab,
        });
      } else {
        _context.commit("mutationGadgets", responseData);

        // this is used for lazy loading (mobile)
        _context.commit("mutationGadgetsAll", responseData);
      }

      // meta
      _context.commit("mutationGadgetsMeta", response.meta);
      return response;
    } catch (error) {
      _context.commit("mutationGadgets", []);
      _context.commit("mutationGadgetsAll", []);
      _context.commit("mutationGadgetsMeta", {});

      throw error;
    }
  },

  // ITEM LIST
  async listGadgetCategory(_context, payload) {
    try {
      const response = await (this as any).$api.call("smartphone.categories", payload);
      const responseData = response.data;

      _context.commit("mutationGadgetCategory", responseData);

      return response;
    } catch (error) {
      _context.commit("mutationGadgetCategory", {});
      throw error;
    }
  },

  async listBrand(_context, payload) {
    try {
      const response = await (this as any).$api.call("smartphone.brand", payload);
      const responseData = response.data;

      _context.commit("mutationListBrand", responseData);

      return response;
    } catch (error) {
      _context.commit("mutationListBrand", {});
      throw error;
    }
  },
};

export default actions;
